import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { formatDate } from '@angular/common';

import { DateFormat } from '../enum/date-format.enum';

// Every date on a screen goes through here, so a format is changed in one place.
@Pipe({
    standalone: false,
    name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
    private readonly locale = inject(LOCALE_ID);

    transform(value: string | Date | null | undefined, format = DateFormat.DATE): string {
        return value ? formatDate(value, format, this.locale) : '';
    }
}
